import React from "react";
import { Stack, Typography } from "@mui/material";

import { useGetAttachments } from "../../hooks/react-query/useAttachmentsData";
import { getCategoryLabel } from "../../constants/attachments";

import AttachmentList from "./AttachmentList";
import AttachmentUploader from "./AttachmentUploader";

export const AttachmentSection = ({
  resourceType,
  resourceId,
  categories,
  accept,
  allowDelete = true,
  compact = false,
  metadataDefaults,
}) => {
  const { data, isLoading } = useGetAttachments({
    resourceType,
    resourceId,
  });

  return (
    <Stack gap="10px" sx={{ overflow: "hidden" }}>
      {!compact && (
        <Typography variant="boldCaptionL" sx={{ marginLeft: "4px" }}>
          Attachments
        </Typography>
      )}

      <AttachmentUploader
        resourceType={resourceType}
        resourceId={resourceId}
        categoryOptions={categories}
        label="Drop files here"
        accept={accept}
        metadataDefaults={metadataDefaults}
      />

      {isLoading ? (
        <Typography variant="caption" color="text.secondary" fontSize={10}>
          Loading…
        </Typography>
      ) : (
        <AttachmentList
          attachments={data || []}
          allowDelete={allowDelete}
          showCategory
        />
      )}
    </Stack>
  );
};

export { getCategoryLabel };

export default AttachmentSection;
